"use client";

import { avatarsSchema } from "../../../lib/types/schema/user/avatarsSchema";
import type { UseRequestQueryProps } from "../../../request/hooks/useRequestQuery";
import { useRequestQuery } from "../../../request/hooks/useRequestQuery";
import { keyAvatars } from "./keyAvatars";

export const useRequestAvatars = ({ ...props }: UseRequestQueryProps = {}) => ({
  query: useRequestQuery({
    ...props,
    queryFnRequestProps: {
      schema: avatarsSchema,
      urlBackendPath: "/avatars",
    },
    queryKey: keyAvatars(),
  }),
});
